
export default function Testimonials() {
  const testimonials = [
    {
      name: 'Marcus Chen',
      role: 'Corporate Event Planner',
      company: 'Luxury Events Co.',
      content: 'Elite Rolling Services transformed our corporate retreat into an unforgettable experience. Their professionalism and attention to detail exceeded all expectations.',
      rating: 5,
      image: 'https://public.readdy.ai/ai/img_res/cafeb0354d86f74f6593b1ed54122405.jpg'
    },
    {
      name: 'Isabella Rodriguez',
      role: 'Private Client',
      company: 'Exclusive Gatherings',
      content: 'The discretion and quality of service provided for my private celebration was exceptional. Every guest was impressed with the sophisticated setup.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Elegant%20Hispanic%20woman%20with%20sophisticated%20styling%20in%20luxurious%20setting%20wearing%20designer%20clothing%20with%20confident%20expression%20representing%20high-end%20private%20event%20clientele&width=400&height=400&seq=testimonial-2&orientation=squarish'
    },
    {
      name: 'David Thompson',
      role: 'Entertainment Executive',
      company: 'Premier Productions',
      content: 'Working with Elite Rolling Services has been a game-changer for our VIP events. Their team understands the importance of creating the perfect atmosphere.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Distinguished%20Caucasian%20executive%20in%20premium%20business%20attire%20with%20confident%20demeanor%20in%20upscale%20entertainment%20industry%20office%20setting%20with%20modern%20sophisticated%20decor&width=400&height=400&seq=testimonial-3&orientation=squarish'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4">
            Trusted by Elite Clients
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our commitment to excellence has earned us the trust of discerning clients 
            who demand nothing but the best for their exclusive events.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex items-center mb-6">
                <img 
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover object-top mr-4"
                />
                <div>
                  <h4 className="font-bold text-gray-900">{testimonial.name}</h4>
                  <p className="text-sm text-gray-600">{testimonial.role}</p>
                  <p className="text-sm text-emerald-600">{testimonial.company}</p>
                </div>
              </div>
              
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400"></i>
                ))}
              </div>
              
              <p className="text-gray-700 italic">"{testimonial.content}"</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
